// axios
import axios from 'axios'

// Determine API base URL based on environment
const getBaseURL = () => {
  // First, try to use environment variable if available
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }
  
  // Fallback: Check if we're in development/local environment
  if (process.env.NODE_ENV === 'development' || 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('.local')) {
    return 'http://api.haio.local/v1/'
  }
  
  // Production environment fallback
  return 'https://api.haio.ir/v1/'
}

const baseURL = getBaseURL()
const timeout = process.env.VUE_APP_API_TIMEOUT || 30000

// Log the API configuration for debugging (remove in production if needed)
console.log('API Configuration:', {
  baseURL,
  timeout,
  environment: process.env.NODE_ENV
})

const axiosInstance = axios.create({
  baseURL,
  timeout: parseInt(timeout),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Set Authorization header from localStorage if token exists
const accessToken = localStorage.getItem('accessToken')
if (accessToken) {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

export default axiosInstance
